<div class="app-mam-follower fx-panel">
  <div class="card bg-dark-lighter text-white">
    <div class="card-body">
      <div class="row mb-1">
        <div class="col-md-2 col-xs-12">
          <span class="text mx-2">Categories
          </span>
          <div class="type-group">
            <p-dropdown
            [options]="searchType"
            [(ngModel)]="condition.search_by"
            optionValue="value"
            optionLabel="name"
            styleClass="form-control bg-dark"
            name="code"
            [autoDisplayFirst]="false"
            appendTo="body"
          ></p-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-xs-12" style="padding-left: 0;">
          <span class="text mx-2">
          </span>
          <div class="input-group search-group">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              placeholder="Search"
              [(ngModel)]="condition.keyword"
            />
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="searchData()"
              >
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>

          </div>
        </div>
        <div class="col-12 col-md-7 mb-2 export-data align-items-baseline d-flex justify-content-end">
          <div>
            <div class=" d-inline-block">
              <span class="text mx-2">From
              </span>
              <div class="d-flex flex-column">
                <p-calendar
                  name="start_time"
                  [(ngModel)]="condition.from"
                  [required]="condition.to&&showError?true:false"
                  #from="ngModel"
                  [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                  [dateFormat]="'dd/mm/yy'"
                  [timeOnly]="false"
                  [showIcon]="true"
                  [showSeconds]="true"
                  [showTime]="true"
                  inputStyleClass="form-control"
                ></p-calendar>
              <small class="error-message text-red" *ngIf="showError && (from.errors?.required)" >
                Required
              </small>
              </div>
            </div>
            <div class="  d-inline-block ml-2" >
              <span class="text mx-2">To
              </span>
                <div class="d-flex flex-column">
                  <p-calendar
                    name="end_time"
                    [(ngModel)]="condition.to"
                    [required]="condition.from&&showError?true:false"
                    #to="ngModel"
                    [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                    [dateFormat]="'dd/mm/yy'"
                    [timeOnly]="false"
                    [showSeconds]="true"
                    [showIcon]="true"
                    [showTime]="true"
                    inputStyleClass="form-control"
                  ></p-calendar>
                  <small class="error-message text-red" *ngIf="showError && (to.errors?.required)" >
                    Required
                  </small>
                  <small class="error-message text-red" *ngIf="showError && condition.to<condition.from" >
                    To date must be later than From date
                  </small>
                </div>
            </div>
            <br>
            <span class="fs-12" style="font-style: italic;">*Please select period to export or skip it if you want to export all data.</span>

          </div>
          <button class="btn btn-primary ml-2 export-btn"
            pTooltip="Export Data"
            type="button"
            tooltipPosition="bottom"
            (click)="export()"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
          <button
            class="btn btn-main ml-2"
            pTooltip="Refresh Data"
            tooltipPosition="bottom"
            type="button"
            (click)="onRefresh()"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col d-flex justify-content-end align-content-center">
        <div class="d-flex" *ngIf="isExpandAll"><span class="mr-5">Collapse</span><mat-icon (click)="expandAll(false)" style="cursor:pointer;">center_focus_weak</mat-icon></div>
        <div *ngIf="!isExpandAll"><span class="mr-5">Expand All</span><i (click)="expandAll(true)" class="fa fa-arrows-alt" aria-hidden="true"></i></div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="rox-table bg-dark" style="border: 1px solid #554E51 ;">
          <thead>
            <tr>
              <th class="sortable mw-100 text-center" (click)="sorting('id')">
                ID
                <i
                  class="fa fa-{{
                    condition.orderBy === 'id'
                      ? sort.id === 'asc'
                        ? 'sort-asc'
                        : 'sort-desc'
                      : 'sort'
                  }}"
                ></i>
              </th>
              <th class="sortable mw-100 text-center" (click)="sorting('username')">
                <span class="mr-20">User Name</span>
                <i
                class="fa flex-end fa-{{
                  condition.orderBy === 'username'
                    ? sort.username === 'asc'
                      ? 'sort-asc'
                      : 'sort-desc'
                    : 'sort'
                }}"
              ></i>
              </th>
              <th class="text-center">Username (JP)</th>
              <th class="sortable mw-100 text-center" (click)="sorting('email')">
                Email
                <i
                  class="fa fa-{{
                    condition.orderBy === 'email'
                      ? sort.email === 'asc'
                        ? 'sort-asc'
                        : 'sort-desc'
                      : 'sort'
                  }}"
                ></i>
              </th>
              <th class="text-center">IB Type
                <select
                id="banking-withdraws-select"
                class="fx-select bg-dark-lighter text-white"
                name="ddlType"
                [(ngModel)]="condition.filter"
                (change)="getListAffiiates()"
              >
                <option value="">All</option>
                <option
                  value="{{ opt.value }}"
                  *ngFor="let opt of selectedType; let i = index"
                >
                  {{ opt.label }}
                </option>
              </select>
              </th>
              <th class="text-center">Level</th>
              <th class="text-center">Rank</th>
              <th class="text-center" *ngIf="permission.allowCreating">MT5 Account(s)</th>
              <th class="text-center" *ngIf="permission.allowCreating">MT5 Group(s)</th>
              <th class="text-center">KYC</th>
              <th class="sortable mw-100 text-center" (click)="sorting('status')">
                Status
                <i
                  class="fa fa-{{
                    condition.orderBy === 'status'
                      ? sort.status === 'asc'
                        ? 'sort-asc'
                        : 'sort-desc'
                      : 'sort'
                  }}"
                ></i>
              </th>
              <th class="text-center"></th>
          </thead>
          <tbody>
            <ng-container *ngFor="
            let item of data
              | paginate
                : {
                    id: 'afiliates',
                    itemsPerPage: pageInfo.pageSize,
                    currentPage: pageInfo.pageIndex,
                    totalItems: pageInfo.totalRecord
                  };
            let i = index
          ">
            <tr class="bordered"
            >
              <td class="text-center bordered" style="border: 1px solid #554E51 !important;">
                <a pTooltip="View IB Tree" tooltipPosition="top"
                  class="text-main {{
                    permission.allowCreating ? '' : 'ignore-click'
                  }}"
                  data-bs-toggle="modal"
                  data-bs-target="#modalIBNetwork"
                  (click)="selectedItem=item"
                  >{{ item.userId }}</a
                >
              </td>
              <td class="text-center bordered">{{ item.getUsername() }}</td>
              <td class="text-center bordered">{{ item.getUsernameJP() }}</td>
              <td class="text-center bordered">
                <a  pTooltip="View IB Details" tooltipPosition="top"
                  class="text-main {{
                    permission.allowCreating ? '' : 'ignore-click'
                  }}"
                  (click)="getIB(item)"
                  >{{ item.email }}</a
                >
              </td>
              <td class="text-center bordered">{{ viewType(item.type) }}</td>
              <td class="text-center bordered">{{ item.level }}</td>
              <td class="text-center bordered">{{item.ranking?.name}}
                <i pTooltip="Edit Rank" tooltipPosition="top" (click)="editRank(item)"  class="fa fa-pencil-square-o ml-2 icon  f-right" data-bs-toggle="modal"
              data-bs-target="#modalEditRank"></i>
              </td>
              <td class="text-center" *ngIf="permission.allowCreating">
                <a
                  href="javascript:void(0)"
                  class="text-blue-lighter"
                  (click)="getIbMT4Info(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAccountMt4"
                  ><i class="fa fa-eye"></i></a
                >
              </td>
              <td class="text-center bordered" *ngIf="permission.allowCreating">
                <a
                  href="javascript:void(0)"
                  class="text-blue-lighter"
                  (click)="getIbInfo(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAsset"
                  ><i class="fa fa-eye"></i></a
                >
              </td>
              <td class="text-center bordered">
                <span [innerHtml]="item.getKYC()"></span>
              </td>
              <td class="text-center bordered">
                <div class="" *ngIf="item.active === 1">
                  <span class="account-status active mr-5">Active</span>
                  <i  pTooltip="Disable Account" type="button" tooltipPosition="top"(click)="openConfirmInvalidateDialog(item)" class="fa fa-lock" aria-hidden="true"></i>
                </div>
                <span class="account-status un-active" *ngIf="item.active !== 1">Inactive</span>
              </td>
              <td class="text-center bordered" (click)="item.isExpand = !item.isExpand;checkExpandAll()">
                <i *ngIf="!item.isExpand" class="fa fa-chevron-right" aria-hidden="true"></i>
                <i *ngIf="item.isExpand" class="fa fa-chevron-down" aria-hidden="true"></i>
              </td>
            </tr>
            <tr *ngIf="item.isExpand" class="bg-dark-lighter">
              <td colspan="12">
                <div>
                  <table class="mt-3 mb-3" style="margin: 0 auto; width: 96%; border: 1px solid #554E51;">
                    <thead>
                      <tr>
                        <td class="text-center" colspan="6">User</td>
                        <td class="text-center" colspan="5">IB</td>
                      </tr>
                      <tr>
                        <td class="text-center">Total User</td>
                        <td class="text-center">Total Lot</td>
                        <td class="text-center">Currency</td>
                        <td class="text-center">Total Lot Rebate</td>
                        <td class="text-center">Total Deposit</td>
                        <td class="text-center">Total Credit</td>
                        <td class="text-center">Total IB</td>
                        <td class="text-center">Total Sub IB Com.</td>
                        <td class="text-center">Direct IB reward</td>
                        <td class="text-center">Preceding IB reward<br>(Amount scheme)</td>
                        <td class="text-center">Sub IB reward<br>(% scheme)</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">{{ item.totalUser }}</td>
                        <td class="text-center">
                          {{ item.userData?.totalLot | number }}
                        </td>
                        <td class="text-center">
                          {{item.currency | uppercase}}
                        </td>
                        <td class="text-center">
                          <span>
                            $ {{ item.userData?.affiliateReturn | DecimalPipe:"1.2-2"}}
                          </span>
                        </td>
                        <td class="text-center">
                          {{ item.userData?.deposit | DecimalPipe:fixedNumber[item.currency]}}
                        </td>
                        <td class="text-center">
                          {{ item.userData?.credit | DecimalPipe:fixedNumber[item.currency]}}
                        </td>
                        <td class="text-center">{{ item.ibData?.totalIb }}</td>
                        <td class="text-center">
                          <span>
                            $ {{ item.ibData?.total_sub_ib_reward | DecimalPipe:"1.2-2"}}
                          </span>
                        </td>
                        <td class="text-center">{{ item.ibData?.direct ?? 0 | number:"1.2-2"}}</td>
                        <td class="text-center">{{ item.ibData?.precede_v2 ?? 0 | number:"1.2-2"}}</td>
                        <td class="text-center">{{ item.ibData?.precede_v1 ?? 0 | number:"1.2-2"}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
      <div class="clearfix mt-15 row">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="afiliates"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
          <div class="ml-5" *ngIf="pageInfo.totalRecord > pageInfo.pageSize">
            <span>Page</span>
            <input
              class="ml-2"
              type="number"
              name="pageIndex"
              [(ngModel)]="pageInfo.pageManual"
              (keyup)="onKeyupPage($event)"
            />
            <button
              class="btn btn-primary ml-2"
              style="padding: 2px 0.75rem"
              (click)="pageChanged(pageInfo.pageManual)"
            >
              Go
            </button>
          </div>
        </div>
        <div class="col-auto">
          <span class="data-info pull-right"
            >Total Records: {{ pageInfo.totalRecord }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade fx-modal" id="modalAsset">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="modal-title font-bold" style="margin-bottom: 0">
          {{ itemIB.name }}
          &nbsp; ({{ itemIB.userName }})
        </h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <table class="rox-table table-bordered bg-dark" *ngIf="itemIB.data">
          <thead>
            <tr>
              <th class="text-center">No</th>
              <th class="text-center">MT5 Group</th>
              <!-- <th class="text-center">Commission (%)</th>
              <th class="text-center">Pip</th>
              <th class="text-center">Percentage (%)</th> -->
              <th class="text-end" *ngIf="permission.allowUpdating"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of itemIB.data; let i = index">
              <td class="text-center">{{ i }}</td>
              <td class="text-center">
                <span labelGroup="{{ item.name }}"></span>
              </td>
              <!-- <td class="text-center">{{ item.data.commission }}</td>
              <td class="text-center">{{ item.data.pip }}</td>
              <td class="text-center">
                <input
                  type="number"
                  [(ngModel)]="item.data.rate"
                  [disabled]="
                    !isEdit || currentIndexEdit != item.group_config_id
                  "
                />
              </td> -->
              <td class="text-end" *ngIf="permission.allowUpdating">
                <i
                  class="fa fa-save"
                  *ngIf="isEdit && currentIndexEdit == item.group_config_id"
                  (click)="onSave(item)"
                ></i>
                <i
                  class="fa fa-edit"
                  *ngIf="!isEdit || currentIndexEdit != item.group_config_id"
                  (click)="onEdit(item)"
                ></i>
                <i
                  class="fa fa-ban"
                  *ngIf="isEdit && currentIndexEdit == item.group_config_id"
                  (click)="onEdit(null)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal fade fx-modal" id="modalAccountMt4">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
    <div class="modal-content" *ngIf="selectedAccount != undefined">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="modal-title font-bold" style="margin-bottom: 0">
          {{ selectedAccount.name }}
          &nbsp; ({{ selectedAccount.userName }})
        </h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <table class="rox-table table-bordered bg-dark" *ngIf="selectedAccount.data">
          <thead>
            <tr>
              <th class="text-center">No</th>
              <th class="text-center">Account Type</th>
              <th class="text-center">Leverage</th>
              <th class="text-center">Credit</th>
              <th class="text-center">Balance</th>
              <th class="text-end">Currency</th>
              <th class="text-end">MAMPAMM</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedAccount.data; let i = index">
              <td class="text-center">{{ item.login }}</td>
              <td class="text-center">{{ item.getAccountType() }}</td>
              <td class="text-center">{{ item.leverage }}</td>
              <td class="text-center">
                <span
                  labelNumber="{{ item.credit }}"
                  [currency]="item.currency"
                ></span>
              </td>
              <td class="text-center">
                <span
                  labelNumber="{{ item.balance }}"
                  [currency]="item.currency"
                ></span>
              </td>
              <td class="text-end">{{ item.currency | uppercase }}</td>
              <td class="text-end">{{ item.isMam === 0 ? 'No' : 'Yes' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<button
  class="btn hidden"
  data-bs-toggle="modal"
  data-bs-target="#modalIBNetwork"
></button>
<div class="modal fade fx-modal" id="modalIBNetwork" >
  <div
    class="modal-dialog modal-xl modal-fixed modal-dialog-centered modal-shadow"
  >
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="modal-title font-bold" style="margin-bottom: 0">IB TREE</h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          &times;
        </button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="root">
          <div class="root__id">
            ID <span class="text-green">{{ selectedItem?.userId }}</span>
          </div>
          <div class="root__name">
            User Name
            <span class="text-green"
              >{{ selectedItem?.firstName }} {{ selectedItem?.lastName }}</span
            >
          </div>
        </div>
        <hr />
        <div class="ib-network">
          <div class="ib-network__tree">
            <fx-ib-network
              [ib]="selectedItem"
              [ibID]="selectedItem"
              (selectItem)="onSelectItem($event)"
            ></fx-ib-network>
          </div>
          <div class="ib-network__info">
            <table class="rox-table no-bordered">
              <tr>
                <td>Introducer ID</td>
                <td class="text-green">{{ selectedData?.parentId }}</td>
              </tr>
              <tr>
                <td>{{ selectedData?.type === 1 ? "IB ID" : "User ID" }}</td>
                <td class="text-green">{{ selectedData?.user_id }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td class="text-green">{{ selectedData?.email }}</td>
              </tr>
              <tr *ngIf="selectedData?.type == 1">
                <td>Current Level</td>
                <td class="text-green">{{ selectedData?.level }}</td>
              </tr>
              <tr>
                <td>Total Asset</td>
                <td class="text-green">
                  <span>{{selectedData?.total_asset | DecimalPipe : '1.2-2'}}</span>
                  {{ selectedData?.total_asset ? "USD" : "" }}
                </td>
              </tr>
              <tr>
                <td>Total trading lot</td>
                <td class="text-green">
                  <span
                    labelNumber="{{ selectedData?.total_lot }}"
                    [currency]="'usd'"
                  ></span>
                </td>
              </tr>
              <tr *ngIf="selectedData?.total_balance !== undefined">
                <td>Total balance</td>
                <td class="text-green">
                  <span
                    labelNumber="{{ selectedData?.total_balance }}"
                    [currency]="'jpy'"
                  ></span>
                </td>
              </tr>
              <tr *ngIf="selectedData?.total_deposit !== undefined">
                <td>Total Deposit</td>
                <td class="text-green">
                  <span
                    labelNumber="{{ selectedData?.total_deposit }}"
                    [currency]="'jpy'"
                  ></span>
                </td>
              </tr>
              <tr *ngIf="selectedData?.total_withdraw !== undefined">
                <td>Total Withdraw</td>
                <td class="text-green">
                  <span
                    labelNumber="{{ selectedData?.total_withdraw }}"
                    [currency]="'jpy'"
                  ></span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade fx-modal" id="modalEditRank" #modalEditRank>
  <div class="modal-dialog modal-lg modal-dialog-centered modal-shadow">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Edit Rank</h4>
        <button type="button" class="close"  data-bs-dismiss="modal" (click)="reset()">
          &times;
        </button>
        <br>
      </div>
      <!-- Modal body -->
      <form class="form form-horizontal" autocomplete="off" #form="ngForm" (ngSubmit)="onSubmitRank()">

      <div class="modal-body mb-3">
          <div class="row mb-3 px-5">
            <div class="col-3 mb-2">Current rank</div>
            <div class="col-9"> {{this.rankName}}</div>
            <!-- <div class="col-3 mb-2">Expiry date</div>
            <div class="col-9"> {{expiryDate ? (expiryDate | date:"dd/MM/yyyy") : 'Not set'}}</div> -->

            <div class="col-12 mt-2" >
              <small style="color: #67677A;" >
                If new rank is not setup, user will keep going with the current rank
              </small>
            </div>
            <div class="col-3 mt-2">New rank</div>
            <div class="col-9 mt-2">
              <div class="col-auto">
                <p-dropdown
                  [options]="selectedRank"
                  optionValue="id"
                  optionLabel="name"
                  styleClass="form-control bg-dark"
                  panelStyleClass="fx-ui-datepicker"
                  [(ngModel)]="model.rank"
                  #rank="ngModel"
                  name="rank"
                  [autoDisplayFirst]="false"
                  placeholder="Select rank"
                ></p-dropdown>
              </div>
              <div class="errors-group">
                <small class="error-message" *ngIf="rank.errors?.required && (rank?.dirty || rank?.touched || form?.submitted)">
                  This field is required
                </small>
              </div>
            </div>
            <!-- <div class="col-3 mt-2">Expiry date</div>
            <div class="col-9 mt-2">
              <div class="col-auto">
                <p-calendar  name="expire_time"
                  [placeholder]="'Select month'"     icon="fa fa-calendar" [(ngModel)]="model.expire_time"
                  panelStyleClass="fx-ui-datepicker" view="month" #expire_time="ngModel" appendTo="body"[dateFormat]="'mm/yy'" [minDate]="currentDate"  [showIcon]="true"
                  ></p-calendar>
                <span class="calender-time"></span>
                <br>
                <small style="color: #67677A;" >
                  User rank will change back to Bronze after the last day of month if set
                </small>

              </div>
            </div> -->
          </div>
      </div>
      <div class="modal-footer">
        <button
          type="reset"
          class="mw-120 btn btn-transparent rounded"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button type="submit" [disabled]="!rank.dirty || !form.valid" class="btn btn-red rounded mw-120" >
          Save
        </button>
      </div>
    </form>

    </div>
  </div>
</div>
<ng-template #confirmInvalidate>
  <div class="dialog-box">
    <div class="dialog-header">Are you sure to disable this account</div>
    <div class="d-flex justify-content-center mt-3">
      <button class="btn-outline-do" mat-button color="warn" (click)="onInvalidate()">Disable</button>
      <button class="btn-outline-cancel ms-2" mat-button [mat-dialog-close]="true" cdkFocusInitial cdkTrapFocus>Cancel</button>
    </div>
  </div>
</ng-template>
